import axios from 'axios'
import store from '@/store'
import { sysAppId } from '@/settings.js'
import { default as expiresCalculation, getExpiresTime, minExpTime } from './expires'
import {getOperateTime,setOperateTime,getLogoutFlag} from '../utils/auth.js'
import router from '@/router'
import { Message } from "element-ui"
import qs from 'qs'
// 处理请求数据 9101
const whiteList = [
  '/api/Jwt/token',
  '/api/Jwt/RefreshAccessToken', // 更新token
  '/api/Jwt/RefreshCache', // 刷新redis缓存
  '/api/Jwt/VerificationCodeSMS', // 获取验证码
  '/api/Jwt/VerificationCodeLogin', // 验证码登录
  '/api/Jwt/RefreshToken', // 令牌过期的token刷新
  '/integration-master/api/qr/qrlogin',//获取二维码地址
  '/integration-master/api/qr/getLoginStatus',//获取二维码状态
  '/api/Jwt/HIStoken',//账号+姓名登录
  '/api/SysUserCa/GetCaQrCode',//获取二维码
  '/api/SysUserCa/CaQrCodeLogin',//二维码登录
  '/api/Jwt/opendidlogin',//一键登录登录
  '/api/Jwt/logout',//退出系统
  '/api/Jwt/tokensm2',//国密2登录
  '/api/Jwt/usercodesm2',//国密2用户登录
  '/dashboard/get_nonce/',//获取随机数
  '/dashboard/verify_signature/',//第三方验签
  '/api/SysAppConfig/GetConfigList',//获取系统配置
  '/key/v3/generateRandom',
  '/SignService'
]
const qsUrl = ['/v2.1/dictionary_multi/file', '/key/v3/generateRandom']
let isRefreshing = false // 控制登录过期的提示锁
let requests = [] // 缓存token刷新，需要重新发起的请求

const service = axios.create({
  baseURL: window.g.API_ROOT,
  timeout: window.g.AXIOS_TIMEOUT || 5000
})

service.interceptors.request.use(
  async config => {
    if (config.headers['Content-Type'] !== 'multipart/form-data' && qsUrl.indexOf(config.url) >= 0) {
      if (config.method === 'post' || config.method === 'POST') {
        config.data = qs.stringify(config.data)
      }
    }
    let operateTime = window.g.operateTime || 1440
    // 请求拦截
    if(getOperateTime() && new Date().getTime() - getOperateTime() > operateTime * 60 * 1000 && !whiteList.includes(config.url)){//30分钟未发送过请求就退出系统 排除掉白名单的接口 不然logout容易死循环
       await store.dispatch('user/logout')
        router.push('/login')
        Message.error('长时间未操作系统，请重新登录')
        return Promise.resolve()
    }else if(!getLogoutFlag() || getLogoutFlag() === 'false' || getLogoutFlag() === 'undefined' || getLogoutFlag() === 'null'){
        setOperateTime(new Date().getTime())
        if(isRefreshing && !whiteList.includes(config.url)){
          // 拦截在刷新token时，同步发送的请求，待 token 刷新后再发起请求
          return new Promise(resolve => {
            // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
            requests.push(token => {
                config.headers['Authorization'] = 'Bearer ' + token
                config.headers['sysappid'] = sysAppId
              resolve(config)
            })
          })
        }else if(config.url === '/key/v3/generateRandom'){
            config.headers['appId'] = 'fg4F31B970CA73A180D43F2CE00262D6BC'
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
            return config
        }else if(config.url === '/SignService'){
            config.headers['ReqType'] = 'AttachedVerifyProcessor'
            config.headers['AccessAuthCode'] = 'fEgNCco3Yg9h5ZUglD3CZJT4IB5='
            config.headers['Content-Type'] = 'application/json'
            return config
        }else{
          const expiresTime = getExpiresTime()
          // 判断接口是否需要 token
          if(!whiteList.includes(config.url) && expiresTime < minExpTime) {
            isRefreshing = true
            // 令牌时间本地计算，未过期执行
            return expiresCalculation().then(async ()=>{
              // token 判断或token 刷新后继续请求
              let token = store.getters.token
              if (token) {
                // 已经刷新了token，将所有队列中的请求进行重试
                requests.forEach(cb => cb(token))
                requests = []
                config.headers['Authorization'] = 'Bearer ' + token
                config.headers['sysappid'] = sysAppId
              }
              isRefreshing = false
              return config
            }).catch(()=>{
              // 请求更新token失败，重置拦截
              isRefreshing = false
              return Promise.reject()
            })
          }else{
            // 未过期，正常流程
            let token = store.getters.token
            if (token) {
              config.headers['Authorization'] = 'Bearer ' + token
              config.headers['sysappid'] = sysAppId
            }
            return config
          }
        }
    }else{
        return Promise.reject()
    }
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    // 响应拦截
    // console.log(response.data)
    const status = response.status
    const code = response.data ? response.data.code : 0
    // 授权失败 401，访问令牌失效 403
    if((status === 401 && code === 10050) || ((status === 401 || status === 403) && code === 10040) ) {
      if(isRefreshing){
        // 拦截在刷新token时，同步发送的请求，待 token 刷新后再发起请求
        return new Promise(resolve => {
          // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
          requests.push(token => {
            config.headers['Authorization'] = 'Bearer ' + token
            config.headers['sysappid'] = sysAppId
            resolve(service(config))
          })
        })
      }else{
        isRefreshing = true
        // 令牌时间本地计算，未过期执行
        return expiresCalculation().then(()=>{
          // token 判断或token 刷新后继续请求
          let token = store.getters.token
          if (token) {
            // 已经刷新了token，将所有队列中的请求进行重试
            requests.forEach(cb => cb(token))
            requests = []
            config.headers['Authorization'] = 'Bearer ' + token
            config.headers['sysappid'] = sysAppId
          }
          isRefreshing = false
          return service(config)
        }).catch(()=>{
          // 请求更新token失败，重置拦截
          isRefreshing = false
          return Promise.reject(false)
        })
      }
    }
    // 正常返回
    return response
  },
  error => {
    return Promise.resolve(error.response)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/api/request.js